module.exports = __webpack_public_path__ + "static/media/ye.ad22a6ef.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ye.svg
// module id = 2245
// module chunks = 0